import { ControlConstants } from "@lib/titan2/dist/game/control/constant/ControlConstants";
import { ButtonProperties } from "@lib/titan2/dist/game/control/properties/ButtonProperties";
import { PagingProperties } from "@lib/titan2/dist/game/control/properties/PagingProperties";
import { SpriteProperties } from "@lib/titan2/dist/game/control/properties/SpriteProperties";
import { TextFieldProperties } from "@lib/titan2/dist/game/control/properties/TextFieldProperties";
import { CommonLang } from "@lib/titan2/dist/game/view/lang/CommonLang";
import { AbstractLoaderProperties } from "@lib/titan2/dist/game/view/properties/AbstractLoaderProperties";
import { LoaderFontStyle } from "@lib/titan2/dist/game/view/style/CommonFontStyle";
import { LoaderStyle } from "@lib/titan2/dist/game/view/style/CommonStyle";
import { LoaderDialog } from "../display/LoaderDialog";
/**
 * AbstractLoaderDialogProperties.ts
 */
export class AbstractLoaderDialogProperties extends AbstractLoaderProperties {
    constructor() {
        super();
        this.setDefaultValues();
    }
    equals(other) {
        return super.equals(other) &&
            this.playButtonProperties.equals(other.playButtonProperties) &&
            this.progressBarBackgroundProperties.equals(other.progressBarBackgroundProperties) &&
            this.logoProperties.equals(other.logoProperties) &&
            this.nextButtonProperties.equals(other.nextButtonProperties) &&
            this.previousButtonProperties.equals(other.previousButtonProperties) &&
            this.pagingProperties.equals(other.pagingProperties) &&
            this.swipeProperties.equals(other.swipeProperties) &&
            this._pageProperties.every((val, index) => val.equals(other._pageProperties[index])) &&
            this.progressBarProperties.equals(other.progressBarProperties) &&
            this.progressFieldProperties.equals(other.progressFieldProperties) &&
            this.pageDurationMs === other.pageDurationMs;
    }
    setDefaultValues() {
        super.setDefaultValues();
        this.createDefaultProperties();
        this._pageProperties = [];
    }
    createDefaultProperties() {
        this.progressBarBackgroundProperties = new SpriteProperties(LoaderStyle.PROGRESS_BAR_BACKGROUND, LoaderStyle.MODULE);
        this.logoProperties = new SpriteProperties(LoaderStyle.LOGO, LoaderStyle.MODULE);
        this.backgroundProperties = new SpriteProperties(LoaderStyle.BACKGROUND_ONLY, LoaderStyle.MODULE);
        this.playButtonProperties = new ButtonProperties(LoaderStyle.CONTINUE_BUTTON, LoaderStyle.MODULE);
        this.playButtonProperties.textFieldProperties = new TextFieldProperties(LoaderFontStyle.PLAY_BUTTON, null, CommonLang.LOADER_PLAY_BUTTON);
        this.nextButtonProperties = new ButtonProperties(LoaderStyle.NEXT_BUTTON, LoaderStyle.MODULE);
        this.previousButtonProperties = new ButtonProperties(LoaderStyle.PREVIOUS_BUTTON, LoaderStyle.MODULE);
        this.pagingProperties = new PagingProperties(LoaderStyle.PAGE_BUTTON, LoaderStyle.MODULE);
        this.pageDurationMs = 5000;
        this.progressBarProperties = new SpriteProperties(LoaderStyle.PROGRESS_BAR, LoaderStyle.MODULE);
        this.progressFieldProperties = new TextFieldProperties(LoaderFontStyle.PROGRESS, null, null, ControlConstants.CENTER);
    }
    get pageProperties() {
        this.setDefaultValues();
        return this._pageProperties.slice();
    }
    getTotalPages() {
        return this.pageProperties.length;
    }
    getClass() {
        return LoaderDialog;
    }
    getClassName() {
        return "LoaderDialog";
    }
}
//# sourceMappingURL=AbstractLoaderDialogProperties.js.map